export enum ViewSourceAccessLevel {
    ADMIN = 'ADMIN',
    EDITOR = 'EDITOR',
    EDITORS_SHARE = 'EDITOR_SHARE',
    OWNER = 'OWNER',
    VIEWER = 'VIEWER',
    NONE = 'NONE',
}
